import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { IWidgetCard } from '@entities/widget-card/model/types';
import { Chip } from '@shared/ui';

import cls from '@entities/widget-card/ui/card/WidgetCard.module.css';

export const WidgetCardStatus = ({ status }: { status: IWidgetCard['status'] }) => {
    const { t } = useTranslation();
    if (status === 'available') return null;
    return (
        <Chip
            textContent={t(`WidgetCard.status.${status}`)}
            containerStyles={cn(
                cls.WidgetCardChip,
                status === 'enabled' && cls.connectedChipContainer,
                status === 'disabled' && cls.disabledChipContainer,
                status === 'unavailable' && cls.unavailableChipContainer
            )}
            textStyles={cn(
                status === 'enabled' && cls.connectedChipText,
                status === 'disabled' && cls.disabledChipText,
                status === 'unavailable' && cls.unavailableChipText
            )}
        />
    );
};
